(function() {
// Swipe table
  let startXs;
  let scrollLefts;
  let swipeTable = document.querySelectorAll(".swipeTable");

  swipeTable.forEach( function(element) {
    element.addEventListener("touchstart", function (e) {
      startXs = e.touches[0].pageX;
      scrollLefts = swipeTable.scrollLefts;
    });
  });

  swipeTable.forEach( function(element) {
    element.addEventListener("touchmove", function (e) {
      let x = e.touches[0].pageX - startXs;
      swipeTable.scrollLefts = scrollLefts - x;
    });
  });

// Caption
  let fixedCaptions = document.querySelectorAll('caption');

  function updateCaptions() {
    fixedCaptions.forEach(caption => {
      let container = caption.closest('[class*="table-"]');
      caption.style.width = `${container.clientWidth}px`;
      let scrollPositionLeft = container.scrollLeft;
      caption.style.transform = `translateX(${scrollPositionLeft}px)`;
    });
  }

  document.querySelectorAll('[class*="table-"]').forEach(container => {
    container.addEventListener('scroll', updateCaptions);
  });

  window.addEventListener('resize', updateCaptions);

  updateCaptions();

}());